import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  inicializado: false,
  search: '',
};

export const complianceFiltroSelector = state => state.complianceFiltro;

export const slice = createSlice({
  name: 'complianceFiltro',
  initialState,
  reducers: {
    complianceFiltroResetar: (state) => {
      return { initialState, inicializado: false };
    },
    complianceFiltroAplicar: (state, action) => {
      return { ...state, ...action.payload, inicializado: true, };
    }
  },
  extraReducers: {},
});

export default slice.reducer;

export const { complianceFiltroResetar, complianceFiltroAplicar } = slice.actions;
